const userListFilters = {
  match: {
    name: 'Matching string',
    field: 'match',
    inputType: 'string',
    conditionType: 'term',
    required: true,
    scope: 'google',
  },
  retentionDays: {
    name: 'Look back Window Days',
    inputType: 'number',
    conditionType: 'retention',
    min: 1,
    max: 540,
    step: 1,
    placeholder: ['e.g. 5'],
    required: true,
    scope: 'google',
  },
};

export default userListFilters;
